<template>
  <div class="viewContainer" v-loading="isLoading">
    <div class="container">
      <div class="column">
        <OrderDetailContent
          :orderdata="order"
          :primary-order-data="primaryOrder"
          @onChangeOrder="onChangeOrder"
          @reload="syncOrder"
        />
      </div>
      <div class="column column--right">
        <OrderDetailChat :order="order" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import OrderUsecase from "@/usecases/order.usecase";
import OrderDetailContent from "@/views/OrderDetailContent.module.vue";
import OrderDetailChat from "@/views/OrderDetailChat.module.vue";
import { apiErrorHandler } from "@/services/apiErrorHandler";

export default {
  components: {
    OrderDetailContent,
    OrderDetailChat,
  },
  data () {
    return {
      orderUsecase: new OrderUsecase(),
      order: {},
      /** クライアント操作の基準注文（子注文画面では取得済み親・それ以外は表示中の注文） */
      primaryOrder: null,
      isLoading: false,
    };
  },
  async created () {
    this.syncOrder();
  },
  mounted () {},
  watch: {
    "$route.params.id" () {
      this.syncOrder();
    },
  },
  methods: {
    ...mapActions({
      loadDefaultExpectedShippingDate: "orderForm/loadDefaultExpectedShippingDate",
    }),
    async onChangeOrder (value) {
      this.order = value;
      this.primaryOrder = await this.resolvePrimaryOrder(value);
    },
    showLoader () {
      this.isLoading = true;
    },
    hideLoader () {
      this.isLoading = false;
    },
    async resolvePrimaryOrder (order) {
      const parentOrderId =
        order && order.parentOrder && order.parentOrder.id
          ? order.parentOrder.id
          : order && order.parentOrderId
            ? order.parentOrderId
            : null;
      if (!order || !parentOrderId) {
        return order;
      }
      try {
        const parentOrder = await this.orderUsecase.getOrder({
          orderId: parentOrderId,
        });
        if (parentOrder) {
          return parentOrder;
        }
      } catch (e) {
        /* 親取得失敗時は表示中注文にフォールバック */
      }
      return order;
    },
    async syncOrder () {
      const orderId = this.$route.params.id;
      this.showLoader();
      try {
        const order = await this.orderUsecase.getOrder({ orderId });
        const primaryOrder = await this.resolvePrimaryOrder(order);
        this.$store.commit("orderForm/setOrderId", orderId);
        this.$store.commit("orderForm/setOrderForm", order);

        this.order = order;
        this.primaryOrder = primaryOrder;

        this.loadDefaultExpectedShippingDate();
      } catch (err) {
        apiErrorHandler(this, err);
      } finally {
        this.hideLoader();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/variables.scss";

.container {
  display: flex;
  height: 100%;
  width: 100%;
}
.column {
  height: 100%;
}
.viewContainer {
  width: 100%;
  user-select: none;
}
.column {
  width: 50%;
  float: left;
}
.column--right {
  border-left: 1px solid $--border-color-lighter;
  width: 50%;
  float: right;
}
</style>
